import { setMiniSidenav } from 'context';
import { useArgonController } from 'context';
import Sidenav from 'examples/Sidenav';
import TahunAnggaran from 'pages/TahunAnggaran';
import React, { useEffect, useState } from 'react'
import { decodeToken, isExpired } from 'react-jwt';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import userStore from 'store/userStore';
import logo from "assets/images/logo-buton.png";
import { CustomDescrypt } from 'global/func';
import pimpinanRoutes from './pimpinanRoutes';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Dashboard from './Dashboard';
import Perencanaan from './PerencanaanOPD';
import StrukturAnggaran from './StrukturAnggaran';
import Laporan from './Laporan';
import Tkdn from './Tkdn';
import Belanja from './PaketPekerjaan/Belanja';
import BelanjaModal from './PaketPekerjaan/BelanjaModal';
import ProjekStrategis from './PaketPekerjaan/ProjekStrategis';
import PaketDak from './PaketPekerjaan/PaketDak';
import LokasiPekerjaan from './LokasiPekerjaan';

const TemplatePimpinan = () => {
    const { user, tahunAnggaran, reqCount } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, reqCount: state.reqCount }));
    const logOut = userStore((state) => state.logOut)
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const [decodedUser] = useState(decodeToken(decryptedUser));

    const navigate = useNavigate();
    const location = useLocation();
    const [controller, dispatch] = useArgonController();
    const { miniSidenav, sidenavColor } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);

    useEffect(() => {
        // console.log(user);
        if (user === null) {
            navigate("/", { replace: true });
        }
        else {
            if (isExpired(decryptedUser)) {
                console.log(isExpired(decryptedUser));
                logOut()
                navigate("/", { replace: true });
            }
            else {
                if (decodedUser.role !== 'admin_pimpinan') {
                    navigate("/", { replace: true });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location, reqCount])

    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };

    return (
        tahunAnggaran === null ?
            <>
                <TahunAnggaran />
            </>
            :
            <>

                <Sidenav
                    color={sidenavColor}
                    brand={logo}
                    brandName="TEPRA Kab. Buton"
                    routes={pimpinanRoutes}
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                />
                <DashboardLayout>
                    <DashboardNavbar homePage='/adminp' isMini={miniSidenav} user={decodedUser.nama || ''} dinas={decodedUser.nm_pd || ""} loginId={decodedUser.id || ''} />
                    <Routes>
                    <Route path="" element={<Dashboard />} />
                        <Route path="perencanaan/*" element={<Perencanaan />} />
                        <Route path="struktur-anggaran/*" element={<StrukturAnggaran />} />
                        <Route path="laporan/*" element={<Laporan />} />
                        <Route path="pdn/*" element={<Tkdn />} />
                        <Route path="belanja/*" element={<Belanja />} />
                        <Route path="belanja-modal/*" element={<BelanjaModal />} />
                        <Route path="projek-strategis/*" element={<ProjekStrategis />} />
                        <Route path="paket-dak/*" element={<PaketDak />} />
                        <Route path="lokasi-pekerjaan/*" element={<LokasiPekerjaan />} />
                        {/* <Route path="map-ai/*" element={<MapAI />} /> */}
                        {/* <Route path="opd/*" element={<DaftarOpd />} /> */}
                        {/* <Route path="anggaran-opd/*" element={<AnggaranOpd />} /> */}
                        {/* <Route path="admin-opd/*" element={<AdminOpd />} /> */}
                        {/* <Route path="admin/*" element={<Admin />} /> */}
                        {/* <Route path="kodefikasi-perencanaan/*" element={<KodefikasiPerencanaan />} /> */}
                        {/* <Route path="kodefikasi-rekening/*" element={<KodefikasiRekening />} /> */}
                        {/* <Route path="sumber-pendanaan/*" element={<SumberPendanaan />} /> */}
                    </Routes>
                </DashboardLayout>
            </>
    )
}

export default TemplatePimpinan